<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("menu.coupon") }}
                    </h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <div class="row">

                            <div class="col-md-2 col-xs-12">
                                <base-input
								:label="keywordType"
                                    v-model="orderId"
                                    placeholder="หมายเลขสั่งซื้อ"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>

                            <div class="col-md-2 col-xs-12">
                                <base-input
								:label="keywordType"
                                    v-model="runningNumber"
                                    placeholder="หมายเลขคูปอง"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>


                            <div class="col-auto">
                                <base-button size="md" @click="handleSearch()">
                                    <i class="fas fa-spinner fa-spin " v-if="isLoading"></i>
                                    {{ $t("search") }}</base-button>
                                <base-button size="md" :loading="isLoading" @click="handleExport()" > Export</base-button>
                                <base-button size="md" :loading="isLoading" @click="handleAdvance()" v-if="isAdmin"> Advance</base-button>
                             </div>
                        </div>

                        <div class="row">
                            <div class="col mt-2">
                              Coupon ID : {{  head.id }}  -  {{  head.name }}
                            </div>
                        </div>


                    </template>
                    <!-- end header -->

                    <div>
                        <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light">
                            <!-- order_number -->
                            <el-table-column align="left" :label="$t('number')" min-width="80px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.coupon_number }} </span>

                                </div>
                            </el-table-column>

                            <!-- created_at -->
                            <el-table-column align="left" :label="$t('order_id')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.bo_order_id }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('tracking')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.tracking_number }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('customer')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.fname }}  {{  row.lname }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('phone')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.phone }} </span>
                                </div>
                            </el-table-column>

                            <!-- <el-table-column align="left" :label="$t('date')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.updated_at }} </span>
                                </div>
                            </el-table-column> -->



                            

                            <el-table-column align="right" :label="$t('actions')" min-width="120px">
                                <div slot-scope="{ $index, row }" class="d-flex">

                                    <base-button @click.native="
                                        handleDetail(row)
                                        " class="edit" type="warning" size="sm" icon>
                                        <i class="text-dtac-bt fa fa-list"></i>
                                    </base-button>

                                    <!-- <base-button 
                                        @click.native="handleChangeQRCode(row)" class="edit" type="warning" size="sm"
                                        icon>
                                        <i class="text-dtac-bt fas fa-edit"></i>
                                    </base-button>


                                    <base-button @click.native=" handleClearQR($index, row)" class="btn-link"
                                        type="danger" size="sm" icon >
                                        <i class="text-white fas fa-trash"></i>
                                    </base-button> -->
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0">
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'
import FileInput from "@/components/Inputs/FileInput";
import { undistributeHeight } from '@fullcalendar/core';
import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Coupon/getDataDetail",
            isLoading: "Coupon/isLoading",

            isAdmin: "Auth/isAdmin",
            isOwner: "Auth/isOwner",
            isEmployee: "Auth/isEmployee",
            isAgent: "Auth/isAgent",
        }),



    },
    data() {
        return {
            propsToSearch: ["running_number", "code"],
            selectedRows: [],
            orderId: "",
            trackingNumber : "",
            runningNumber : "",
            headId : "",
            head: {},
        };
    },
    async mounted() {

        this.clearDataDetail();
        this.headId = this.$route.params.id

        if (this.headId == "" ) {
            this.$router.push("/backoffice/coupon");
        }

        try {

            const resp = await this.getData({id: this.headId});
            this.head = resp.data.Datum
        }
        catch (error) {
            console.log(error);
            // this.$router.push("/backoffice/coupon");
        }

    },
    methods: {
        ...mapActions({
            listData: "Coupon/listDataDetail",
            getData: "Coupon/getData",
            listDataDetail: "Coupon/listDataDetail",
            clearDataDetail: "Coupon/clearDataDetail",
        }),
        handleSearch() {
            const params = {
                head_id: this.headId,
                order_id: this.orderId,
                tracking_number: this.trackingNumber,
                running_number: this.runningNumber,
            }
            this.listData(params);
        },
        handleAdvance(){
            this.$router.push("/backoffice/coupon/all/" + this.headId);
        },
        handleExport(){
            let i = 1
			let dataExport = this.tableData.map((v) => {
				return {
				NO: i++,
				CouponNumber: v.coupon_number,
				CouponCode: v.coupon_code,
				Address: v.address,
				SubDistrict: v.subdistrict,
				Distrcit: v.district,
				Province: v.province,
				PHone: v.phone,
				Firstname: v.fname,
				Lastname: v.lname,
				TrackingNumber: v.tracking_number,
				}

			})
			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,'export_coupon.xlsx')

        },
        handleDetail(row) {
            // swal show row.url

            swal.fire ({
                title: 'Coupon Detail',
                html: `
                    <div class="row text-left">
                        <div class="col-4">Coupon Number</div>
                        <div class="col-8">${row.coupon_number}</div>
                    </div>
                    <div class="row text-left">
                        <div class="col-4">Order ID</div>
                        <div class="col-8">${row.bo_order_id}</div>
                    </div>
                    <div class="row text-left">
                        <div class="col-4">Tracking Number</div>
                        <div class="col-8">${row.tracking_number}</div>
                    </div>
                    <div class="row text-left">
                        <div class="col-4">Customer</div>
                        <div class="col-8">${row.fname} ${row.lname}</div>
                    </div>
                    <div class="row text-left">
                        <div class="col-4">Phone</div>
                        <div class="col-8">${row.phone}</div>
                    </div>
                   
                    <div class="row text-left">
                        <div class="col-4">URL</div>
                        <div class="col-8">${row.url}</div>
                    </div>
                `,
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
            })

            
        },

        

        handleCreate() {
            this.$router.push("/backoffice/po/create");
        },

    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
